import { Badge } from "@/components/ui/badge";

export const STATUS_CONFIG = {
  in_stock: { label: "In Stock", className: "bg-amtm-success/15 text-amtm-success border-amtm-success/30" },
  low_stock: { label: "Low Stock", className: "bg-amtm-warning/15 text-amtm-warning border-amtm-warning/30" },
  out_of_stock: { label: "Out of Stock", className: "bg-amtm-textMuted/15 text-amtm-textMuted border-amtm-border" },
  expiring_soon: { label: "Expiring Soon", className: "bg-amtm-warning/15 text-amtm-warning border-amtm-warning/30" },
  expired: { label: "Expired", className: "bg-amtm-error/15 text-amtm-error border-amtm-error/30" },
  depleted: { label: "Depleted", className: "bg-amtm-textMuted/15 text-amtm-textMuted border-amtm-border" },
  ok: { label: "OK", className: "bg-amtm-success/15 text-amtm-success border-amtm-success/30" },
};

export default function InventoryStatusBadge({ status, testId }) {
  const cfg = STATUS_CONFIG[status] || { label: status, className: "bg-amtm-textMuted/15 text-amtm-textMuted" };
  return (
    <Badge variant="outline" className={cfg.className} data-testid={testId}>
      {cfg.label}
    </Badge>
  );
}
